import React from 'react'

const TravelHeaderIconWhite = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="white-glow-travel">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      <circle cx="16" cy="16" r="10" stroke="#ffffff" strokeWidth="2" filter="url(#white-glow-travel)"/>
      
      <ellipse cx="16" cy="16" rx="10" ry="3" stroke="#ffffff" strokeWidth="1.5" opacity="0.6"/>
      <ellipse cx="16" cy="16" rx="10" ry="6" stroke="#ffffff" strokeWidth="1.5" opacity="0.5"/>
      
      <ellipse cx="16" cy="16" rx="3" ry="10" stroke="#ffffff" strokeWidth="1.5" opacity="0.6"/>
      
      <g transform="translate(20, 8) rotate(45 0 0)">
        <path d="M0 0L-2 4L0 3.5L2 4L0 0Z" fill="#ffffff"/>
        <rect x="-0.5" y="-3" width="1" height="3" fill="#ffffff"/>
        <path d="M-2 -1L-3.5 -0.5L-2 0L-2 -1Z" fill="#ffffff"/>
        <path d="M2 -1L3.5 -0.5L2 0L2 -1Z" fill="#ffffff"/>
      </g>
      
      <path 
        d="M6 16C8 10 12 8 16 8C20 8 24 10 26 16" 
        stroke="#ffffff" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeDasharray="2 2"
        opacity="0.5"
      />
      
      <circle cx="10" cy="14" r="1.5" fill="#ffffff" opacity="0.8"/>
      <circle cx="22" cy="18" r="1.5" fill="#ffffff" opacity="0.8"/>
      <circle cx="16" cy="8" r="1.5" fill="#ffffff" opacity="0.8"/>
      
      <circle cx="16" cy="4" r="1" fill="#ffffff" opacity="0.6"/>
      <circle cx="16" cy="28" r="1" fill="#ffffff" opacity="0.6"/>
      <circle cx="4" cy="16" r="1" fill="#ffffff" opacity="0.6"/>
      <circle cx="28" cy="16" r="1" fill="#ffffff" opacity="0.6"/>
    </svg>
  )
}

export default TravelHeaderIconWhite
